import React from 'react';
import styles from './RichTextDisplay.module.css';
import { sanitizeHTML } from '../utils/security';

const RichTextDisplay = ({ content, placeholder }) => {
  // If no content, show placeholder
  if (!content || content.trim() === '' || content === '<p><br></p>') {
    return (
      <p className={styles.placeholder}>
        {placeholder}
      </p>
    );
  }

  // Clean up common empty Quill patterns and sanitize for XSS
  const cleanContent = sanitizeHTML(content)
    .replace(/<p><br><\/p>/g, '') // Remove empty paragraph breaks
    .replace(/<p><\/p>/g, '') // Remove completely empty paragraphs
    .trim();

  if (!cleanContent) {
    return (
      <p className={styles.placeholder}>
        {placeholder}
      </p>
    );
  }

  return (
    <div 
      className={styles.content}
      dangerouslySetInnerHTML={{ __html: cleanContent }}
    />
  );
};

export default RichTextDisplay; 